module.exports = {
  defaultTitle: 'Eric Shek',
  logo: 'https://portfolio.smakosh.com/favicon/favicon-512.png',
  author: 'Eric Shek',
  url: 'http://ericxstone.sol',
  legalName: 'Eric Shek',
  defaultDescription: 'I’m Eric and I’m a Full Stack Blockchain Developer!',
  socialLinks: {
    github: 'https://github.com/ericxstone',
    linkedin: 'https://www.linkedin.com/in/eric-shek-mh',
  },
  googleAnalyticsID: 'G-V2WMDFY285',
  themeColor: '#6398FF',
  backgroundColor: '#6398FF',
  social: {
    github: "ericxstone"
  },
  address: {
    city: 'Hong Kong',
    region: 'Region',
    country: 'Country',
    zipCode: 'ZipCode',
  },
  contact: {
    email: 'email',
    phone: 'phone number',
  },
  foundingDate: '2018',
};
